import React from "react";
import TextField from "@material-ui/core/TextField";

const CustomTextWidget = ({ value, onChange, label, id }) => {
    let numberValue = null;
    if (value) {
        if (value.match(/\d+/)) {
            numberValue = Number(value.match(/\d+/)[0])
        }
    }

    return (
        <TextField
            id={id}
            label={label}
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            fullWidth
            InputProps={{
                style: {
                    backgroundColor: numberValue && numberValue < 80 ? "#FBB5AE" : ""
                }
            }}
            disabled={true}
        />
    );
};

export default CustomTextWidget;
